<template>
  <div>
    <Modal
      :visible="isModal"
      pop_tit="신고정보 수정 사유"
      popSizeClass="popup__container--m"
      @close="closeModal"
    >
      <template #pop_content>
        <h4>신고 정보 수정 사유를 선택해 주세요.</h4>
        <div class="form-group">
          <select
            name="modReason"
            id="modReason"
            v-model="reasonInfo.reasonCode"
            @change="modReasonChange"
          >
            <option
              v-for="item in modReasonCodeList"
              :key="item.cd"
              :value="item.cd"
            >
              {{ item.cdNm }}
            </option>
          </select>
          <textarea
            v-model="reasonInfo.description"
            v-show="showDesc"
            class="form-control mod-description"
            rows="10"
            placeholder="신고 수정 사유 내용을 작성하여 주시기 바랍니다."
          ></textarea>
        </div>
      </template>
      <template #pop_buttons>
        <button type="button" class="btn btn--m btn--blue" @click="setReport">
          수정
        </button>
        <button
          type="button"
          class="btn btn--m btn--line btn--gray"
          @click="closeModal"
        >
          닫기
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import Modal from "@/component/Modal.vue";

export default {
  components: {
    Modal,
  },
  props: {
    isModal: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const axios = inject("axios");

    // data 정의
    const modReasonCodeList = ref([]);
    const showDesc = ref(true);
    const reasonInfo = ref({ reasonCode: "", description: "" });

    // methods 정의
    const getModReasonCodeList = () => {
      axios
        .post("/report/pr/code/mod-reason/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            modReasonCodeList.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    // 셀렉트 박스 선택 시 입력 영역 display 제어
    const modReasonChange = () => {
      showDesc.value = reasonInfo.value.reasonCode === "REPORT_MOD_INPUT";
    };

    const closeModal = () => {
      emit("close");
    };
    const setReport = () => {
      emit("set", reasonInfo.value);
    };

    // life cycle 정의
    onMounted(() => {
      // detail api 호출
      getModReasonCodeList();

      if (reasonInfo.value.reasonCode === "") {
        reasonInfo.value.reasonCode = "REPORT_MOD_INPUT";
      }

      reasonInfo.value.description = "";
    });

    // html에서 사용될 데이터 정의
    return {
      modReasonCodeList,
      modReasonChange,
      showDesc,
      reasonInfo,
      closeModal,
      setReport,
    };
  },
};
</script>

<style>
</style>